import getEnv from "@utils/getEnv";

const getGoogleClientId = (locale?: string): string | undefined => {
  if (locale === "lt") {
    return getEnv("NEXT_PUBLIC_GOOGLE_CLIENT_ID_LT");
  }
  if (locale === "lv") {
    return getEnv("NEXT_PUBLIC_GOOGLE_CLIENT_ID_LV");
  }
  if (locale === "ee") {
    return getEnv("NEXT_PUBLIC_GOOGLE_CLIENT_ID_EE");
  }
  return undefined;
};
export default getGoogleClientId;
